let css = require('./make-order-button.css');
let { cut } = require('../../../../helpers/utils');
let { onCreateOrder, tryRaiseCreateOrderWithFilterMap } = require('../../../../signals/order');
let { raiseEvent } = require('../../../../signals/analytics');
const BUTTON_SELECTOR = cut(css.button);

class MakeOrderButton {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        let isBig = this.$context.props.isBig;
        return this.$context.getWatcherData().then((data) => Object.assign({ isBig }, data, { css }));
    }

    bind () {
        return {
            click: {
                [BUTTON_SELECTOR]: this.onCreateOrderClick
            }
        };
    }

    onCreateOrderClick () {
        this.$context.signal(onCreateOrder);
        let category = 'checkout';
        if (this.$context.props.isUp) {
            category = 'checkout_up';
        }
        this.$context.signal(raiseEvent, { category: category, action: 'click' });
        this.$context.signal(tryRaiseCreateOrderWithFilterMap);
    }
}

module.exports = {
    constructor: MakeOrderButton
};



// WEBPACK FOOTER //
// ./components/order/header/make-order-button/index.js